import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  DialogActions,
  Box,
} from "@mui/material";
import { styled } from '@mui/material/styles';
// hooks
import useResponsive from '../../../hooks/useResponsive'

const GreenText = styled('span')(({ theme }) => {
  return {
    color: theme.palette.oldprimary.main,
  };
});

const ListStyle = styled('ul')(({ theme }) => {
  return {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  }
});

const ListItemStyle = styled('li')(({ theme }) => {
  return {
    ...theme.typography.body2,
  }
});


export default function Before3WayPrepListDialog({ isOpen, closeDialog, prepList }) {
  const smUp = useResponsive('up', 'sm');
  const prepListText = prepList?.split('\r\n');

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="xs">
      <DialogContent sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          사전 미팅때 꼭 <GreenText>준비</GreenText>해주세요!
        </Typography>
        <Typography variant="body2" sx={{ wordBreak: "keep-all", mb: 3 }}>
          크루에게 미팅때 꼭 공유해주세요 <br/>
          사전 미팅 전에 카카오톡으로 리마인드 드릴게요.
        </Typography>
        <Box
          sx={{
            p: { xs: 2, sm: 3 },
            backgroundColor: (theme) => theme.palette.background.neutral,
            borderRadius: 2,
          }}
        >
          <ListStyle>
          {prepListText?.map((text, index) => (
            <ListItemStyle key={index}>
              {text}
            </ListItemStyle>
          ))}
          </ListStyle>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          size="large"
          sx={{ px: 3 }}
          fullWidth={!smUp}
          onClick={closeDialog}
        >
          확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  )
};
